<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTipoDocumento"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="allowEmpty"
    :loading="isLoading"
    label="nome"
    track-by="nome"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum tipo de documento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  props: {
    typeDefault: {
      type: String,
      default: 'cpf'
    },
    nameField: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    emptyLabel: {
      type: String,
      default: 'Selecione'
    },
    includeAll: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (this.includeAll && e.id === 0) {
        this.$emit('input', '');
        this.$emit('selectChange', 'tipo_documento', '');
        return;
      }

      const selectedValue = e ? e.nome : this.allowEmpty ? '' : 'cpf';
      this.$emit('input', selectedValue);
      this.$emit('selectChange', 'tipo_documento', selectedValue);
    },
    labelTipoDocumento(item) {
      return this.$t(item.nome) || item.nome;
    },
    setValue(value) {
      this.selected =
        this.options.find((option) => option.nome === value) ||
        this.options.find((option) => option.nome === (this.allowEmpty ? '' : 'cpf'));
      this.$emit('input', this.selected ? this.selected.nome : this.allowEmpty ? '' : 'cpf');
      this.$emit('selectChange', 'tipo_documento', this.selected ? this.selected.nome : '');
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('tipo_documento', {
          columns: 'id, nome',
          order: 'id'
        })
        .then((res) => {
          let documentos = res.data.map((doc) => ({
            id: doc.id,
            nome: doc.nome
          }));
          if (this.includeAll) {
            documentos.unshift({ id: 0, nome: this.emptyLabel });
          }
          if (!documentos.some((doc) => doc.nome === 'cpf')) {
            documentos.unshift({ id: null, nome: 'cpf' });
          }

          this.options = documentos;
          this.typeDefault = this.$store?.state?.user?.configEmpresa?.tipoDocumentoDefault || '';
          if (this.typeDefault) {
            this.setValue(this.typeDefault);
          } else {
            this.setValue(this.nameField);
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
          this.isLoading = false;
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField(newVal) {
      this.setValue(newVal);
    }
  }
};
</script>

<style lang="scss" scoped></style>
